
// ========== locale ==========
const locale = document.querySelector("html").getAttribute("lang");

// ========== Cart Redirect ==========
if (window.location.pathname.endsWith('cart')) {
  locale == "uk" ?window.location.href = '/uk': window.location.href = '/';
}

// ========== Collections Redirect ==========
if (window.location.pathname.endsWith('collections') || window.location.pathname.endsWith('collections/')){
  locale == "uk" ?window.location.href = '/uk/collections/all': window.location.href = '/collections/all';
}

// ========== Shop Currency==========
const shopCurrency = document.querySelector('html').getAttribute('data-currency');

// ========== Animation On Scroll ==========
window.addEventListener("scroll", animationOnScroll);
window.addEventListener("resize", animationOnScroll);
window.addEventListener("load", animationOnScroll);
let animItems = document.querySelectorAll(".anim-items");

function animationOnScroll() {
  if (animItems.length <= 0) return;
  for (let index = 0; index < animItems.length; index++) {
    const animItem = animItems[index];
    const animItemHeight = animItem.offsetHeight;
    const animItemOffset = offset(animItem).top;
    const animStart = animItem.dataset.animStart;
    let animItemPoint = window.innerHeight - animItemHeight / animStart;
    if (animItemHeight > window.innerHeight) {
      animItemPoint = window.innerHeight - window.innerHeight / animStart;
    }
    if (scrollY > animItemOffset - animItemPoint && scrollY < animItemOffset + animItemHeight) {
      animItem.classList.add("_active");
    } else {
      if (!animItem.classList.contains("anim-stop")) {
        animItem.classList.remove("_active");
      }
    }
  }
}

function offset(el) {
  const rect = el.getBoundingClientRect();
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

// ========== Parallax Image ==========

function getBodyScrollTop() {
  return self.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || (document.body && document.body.scrollTop);
}

document.querySelectorAll(".parallax-img")?.forEach((img) => {
  const imgParent = img.closest(".parallax-container");
  const parallaxImg = () => {
    let speed = img.getAttribute("data-speed");
    let imgY = imgParent.getBoundingClientRect().top + window.pageYOffset; //
    let winY = getBodyScrollTop();
    let winH = window.innerHeight;
    let parentH = imgParent.offsetHeight;
    let winBottom = winY + winH;
    let imgPercent = 0;
    if (winBottom > imgY && winY < imgY + parentH) {
      let imgBottom = (winBottom - imgY) * speed;
      let imgTop = winH + parentH;
      imgPercent = (imgBottom / imgTop) * 100 + (50 - speed * 50);
    }
    if (imgPercent) {
      img.style.top = imgPercent + "%";
      img.style.transform = "translate3d(-50%, -" + imgPercent + "%, 0px)";
    }
  };
  window.addEventListener("scroll", parallaxImg);
  window.addEventListener("resize", parallaxImg);
  window.addEventListener("load", parallaxImg);
});

// ========== Header ==========

  const isBlackTransparent = document.querySelector(".catalog, .events-page, .product, .shopify-policy__container");
  const isWhiteTransparent = document.querySelector(".banner, .about-us, .customize-top");

  if (isBlackTransparent) {
    header.classList.add("_black-transparent");
  } else if (isWhiteTransparent) {
    header.classList.add("_white-transparent");
  }

let prevScroll = 0;
function onScrollHeaderDo() {
  let scrollOfTop = window.pageYOffset || document.documentElement.scrollTop;

  const header = document.querySelector(".header");
  if (scrollOfTop > prevScroll) {
    header.classList.add("_hidden");
  } else {
    header.classList.remove("_hidden");
  }
  prevScroll = scrollOfTop;

  const banner = document.querySelector(".banner");
  const customizeTop = document.querySelector(".customize-top");
  const aboutUs = document.querySelector(".about-us");

  if (banner && scrollOfTop > banner.offsetHeight) {
    header.classList.add("_black-transparent-main");
    header.classList.remove("_white-transparent");
  } else if (customizeTop && scrollOfTop > customizeTop.offsetHeight) {
    header.classList.add("_black-transparent-main");
    header.classList.remove("_white-transparent");
  } else if (aboutUs && scrollOfTop > aboutUs.offsetHeight + document.querySelector(".traditions-footnote").offsetHeight) {
    header.classList.add("_black-transparent-main");
    header.classList.remove("_white-transparent");
  } else {
    header.classList.add("_white-transparent");
    header.classList.remove("_black-transparent-main");
  }
}

window.addEventListener("scroll", onScrollHeaderDo);
window.addEventListener("resize", onScrollHeaderDo);

// ========== Burger Menu ==========
const burgerBtn = document.querySelector(".button-burger");
const toggleBurgerMenu = () => {
  const body = document.querySelector("body");
  body.classList.toggle("_burger-open");
};

function burgerMenuOverlay() {
  const body = document.querySelector("body");
  if (window.innerWidth > 768 && body.classList.contains("_burger-open")) {
    body.classList.remove("_burger-open");
  }
}

burgerBtn && burgerBtn.addEventListener("click", toggleBurgerMenu);
window.addEventListener("resize", burgerMenuOverlay);

// ========== stringSplitUp anim ==========
function stringSplitUp(strSource, destination) {
  let _strSource = strSource.replace(/ {1,}/g, " ");
  let arrDecorTitle = _strSource.trim().split(" ");
  arrDecorTitle.forEach((elem, i) => {
    destination.insertAdjacentHTML("beforeEnd", `<p><span>${elem}</span></p>`);
  });
}

// ========== traditions title  ==========
if (document.querySelector(".traditions__title")) {
  const strSource = document.querySelector(".traditions__title-hidden").textContent;
  const destination = document.querySelector(".traditions__title");
  stringSplitUp(strSource, destination);
}

// ========== traditions text one  ==========
if (document.querySelector(".traditions__text--one")) {
  const strSource = document.querySelector(".traditions__text-hidden--one").textContent;
  const destination = document.querySelector(".traditions__text--one");
  stringSplitUp(strSource, destination);
}

// ========== traditions text two  ==========
if (document.querySelector(".traditions__text--two")) {
  const strSource = document.querySelector(".traditions__text-hidden--two").textContent;
  const destination = document.querySelector(".traditions__text--two");
  stringSplitUp(strSource, destination);
}

// ========== traditions footnote text  ==========
if (document.querySelector(".traditions-footnote__text")) {
  const strSource = document.querySelector(".traditions-footnote__text-hidden").textContent;
  const destination = document.querySelector(".traditions-footnote__text");
  stringSplitUp(strSource, destination);
}

// ========== Section Decor  ==========
if (document.querySelector(".decor__title")) {
  const strSource = document.querySelector(".decor__title-hidden").textContent;
  const destination = document.querySelector(".decor__title");
  stringSplitUp(strSource, destination);
}

// ========== Section Materials  ==========
if (document.querySelector(".materials__title")) {
  const strSource = document.querySelector(".materials__title-hidden").textContent;
  const destination = document.querySelector(".materials__title");
  stringSplitUp(strSource, destination);
}

// ========== Section Process  ==========
if (document.querySelector(".process__title")) {
  const strSource = document.querySelector(".process__title-hidden").textContent;
  const destination = document.querySelector(".process__title");
  stringSplitUp(strSource, destination);
}

// ========== Customize Top Title  ==========
if (document.querySelector(".customize-top__title")) {
  const strSource = document.querySelector(".customize-top__title").textContent;
  const destination = document.querySelector(".customize-top__title-anim");
  stringSplitUp(strSource, destination);
}

// ========== About Title  ==========
if (document.querySelector(".about-us__title")) {
  const strSource = document.querySelector(".about-us__title-hidden").textContent;
  const destination = document.querySelector(".about-us__title");
  stringSplitUp(strSource, destination);
}

// ========== About Title Mobile ==========
if (document.querySelector(".about-us__title-mobile")) {
  const strSource = document.querySelector(".about-us__title-mobile-hidden").textContent;
  const destination = document.querySelector(".about-us__title-mobile");
  stringSplitUp(strSource, destination);
}

// ========== Follow Cursor ==========
const el = document.querySelector(".follow-cursor");
function getTargetElement(e) {
  if (!el || !e.target || document.documentElement.clientWidth < 992 || isMobile.any()) return;

  el.style.transform = "translate3d(" + e.clientX + "px," + e.clientY + "px, 0)";
  e.target.closest(".new-products-card")
    ? el.classList.add("target-watch")
    : el.classList.remove("target-watch");
  e.target.closest(".banner") || e.target.closest(".about-us__cursor-target")
    ? el.classList.add("target-banner")
    : el.classList.remove("target-banner");
  e.target.closest(".customization") ? el.classList.add("target-customization") : el.classList.remove("target-customization");
  e.target.closest(".features") ? el.classList.add("target-features") : el.classList.remove("target-features");
  e.target.closest(".video-player") ? el.classList.add("target-video-player") : el.classList.remove("target-video-player");
  e.target.closest(".video-player .controls") && el.classList.remove("target-video-player");
  e.target.closest(".events-slider .swiper-slide-next") ? el.classList.add("target-events-next") : el.classList.remove("target-events-next");
  e.target.closest(".events-slider .swiper-slide-prev") ? el.classList.add("target-events-prev") : el.classList.remove("target-events-prev");
  e.target.closest(".all-events .events-slider .swiper-slide-active")
    ? el.classList.add("target-events-active")
    : el.classList.remove("target-events-active");
}
document.addEventListener("mousemove", getTargetElement);
!document.querySelector(".events-slider") && document.addEventListener("mouseover", getTargetElement);
!document.querySelector(".events-slider") && document.addEventListener("mouseout", getTargetElement);

// ========== Footer Menu accordion ==========
const accordionBtns = document.querySelectorAll(".footer-menu__header");

const closeAllAccordions = () => {
  accordionBtns.forEach((acc) => {
    acc.classList.remove("is-open");
    acc.nextElementSibling.style.maxHeight = null;
  });
};

accordionBtns.forEach((accordion) => {
  accordion.addEventListener("transitionend", () =>  $("html").getNiceScroll().onResize());
  accordion.addEventListener("click", function () {
    const content = this.nextElementSibling;
    if (content.style.maxHeight) {
      closeAllAccordions();
    } else {
      closeAllAccordions();
      this.classList.toggle("is-open");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});

// ========== Active Nav Links ==========
const headerNavLinks = document.querySelectorAll(".header-navbar__link.hover-link");
const cur_url = window.location.pathname?.replace("/", "");
headerNavLinks.length > 0 &&
  headerNavLinks.forEach((link) => {
    const href = link.getAttribute("href")?.replace("/", "");
    if (cur_url === href) {
      link.classList.remove("hover-link");
      link.classList.add("link-flash");
    }
  });

// ========== language switcher ==========
// const enLanguageButton = document.querySelector('.footer__language-link[data-language="eng"]');
// const uaLanguageButton = document.querySelector('.footer__language-link[data-language="ua"]');

// if (locale == "en") {
//   uaLanguageButton?.setAttribute("href", "/uk" + window.location.pathname);
//   enLanguageButton?.setAttribute("href", window.location.pathname);
// }

// if (locale == "uk") {
//   uaLanguageButton?.setAttribute("href", window.location.pathname);
//   window.location.pathname === "/uk"
//     ? enLanguageButton?.setAttribute("href", "/" + window.location.pathname?.replace("/", "").replace("uk", ""))
//     : enLanguageButton?.setAttribute("href", window.location.pathname?.replace("/", "").replace("uk", ""));
// }




// ========== preloader ==========
window.onload = function () {
 document.body.classList.add("loaded");
};


